// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconTeam = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    fill,
    iconClassName,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 18,
    width: 18,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-team">
      <svg
        className="c-icon-team fill-current"
        width={width || measurements.width}
        height={height || measurements.height}
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5.87832 6.21252C7.62207 6.21252 9.05645 4.8344 9.05645 3.11877C9.05645 1.40315 7.62207 0.0250244 5.87832 0.0250244C4.13457 0.0250244 2.7002 1.40315 2.7002 3.11877C2.7002 4.8344 4.13457 6.21252 5.87832 6.21252ZM5.87832 1.31877C6.91895 1.31877 7.79082 2.1344 7.79082 3.1469C7.79082 4.1594 6.94707 4.97502 5.87832 4.97502C4.80957 4.97502 3.96582 4.1594 3.96582 3.1469C3.96582 2.1344 4.8377 1.31877 5.87832 1.31877Z" fill={fill || ''} />
        <path d="M12.9376 7.5625C14.4563 7.5625 15.6657 6.38125 15.6657 4.89062C15.6657 3.4 14.4282 2.21875 12.9376 2.21875C11.447 2.21875 10.2095 3.4 10.2095 4.89062C10.2095 6.38125 11.447 7.5625 12.9376 7.5625ZM12.9376 3.5125C13.7532 3.5125 14.4001 4.13125 14.4001 4.91875C14.4001 5.70625 13.7532 6.325 12.9376 6.325C12.122 6.325 11.4751 5.70625 11.4751 4.91875C11.4751 4.13125 12.122 3.5125 12.9376 3.5125Z" fill={fill || ''} />
        <path d="M13.0782 7.8438H12.8251C11.9813 7.8438 11.1657 8.09692 10.4626 8.5188C9.70322 7.5063 8.49385 6.8313 7.14385 6.8313H4.64072C2.33447 6.85942 0.506348 8.68755 0.506348 10.9657V12.9907C0.506348 13.525 0.928223 13.9469 1.4626 13.9469H16.5657C17.1001 13.9469 17.5501 13.4969 17.5501 12.9625V12.2875C17.522 9.84067 15.5251 7.8438 13.0782 7.8438ZM1.77197 12.6813V10.9657C1.77197 9.39067 3.06572 8.09692 4.64072 8.09692H7.14385C8.71885 8.09692 10.0126 9.39067 10.0126 10.9657V12.6813H1.77197ZM16.2563 12.6813H11.2501V10.9657C11.2501 10.5157 11.1657 10.0657 11.0251 9.6438C11.5313 9.27817 12.1501 9.10942 12.797 9.10942H13.0501C14.7938 9.10942 16.2282 10.5438 16.2282 12.2875V12.6813H16.2563Z" fill={fill || ''} />
      </svg>
    </Icon>
  );
};

export default IconTeam;
